import { Loader2Icon } from "lucide-react";
import * as React from "react";
import { Button, ButtonProps } from "./ui/button";

type ButtonLoadingProps = {
  isLoading: boolean;
  children: React.ReactNode;
};

export const ButtonLoading = ({
  isLoading,
  children,
  ...props
}: ButtonProps & ButtonLoadingProps) => {
  return (
    <Button disabled={isLoading} {...props}>
      {isLoading ? <Loader2Icon className="w-4 h-4 animate-spin" /> : children}
    </Button>
  );
};
